export default "__VITE_ASSET__L6ndp7vZ__"